class CustomerApplicationService
  constructor: (@$http, @ConfigService, @ApplicationService, @$state, @$stateParams, @$rootScope, @$modal, @$timeout, @$window) ->
    @modal                     = null
    @previously_attempted_path = null
    @static_routes             = ['loading', 'service_failure']

  showLoadingText: (word_array) ->
    @$rootScope.$broadcast 'customer_application:modal_message', word_array.shift()
    if word_array.length > 0
      @$timeout =>
        @showLoadingText word_array
      , 4500

  # DEPRECATED in renderer v5+ (use amountLoadingSpinner directive instead)
  createLoadingModal: (initialMessage = '') ->
    @$rootScope.$broadcast 'submitDisabled', true
    if !@modal
      @modal = @$modal.open(
        templateUrl: "/customer_application_renderer/modals/loading.html"
        windowClass: "loading-modal"
        controller: [
            "$scope", "$modalInstance", "modal_message", ($scope, $modalInstance, modal_message) ->
              $scope.modal_message = modal_message
              $scope.spinnerUrl = require('@amount/frontend-styles/src/images/dec/dec-loading.svg')
              $scope.$on "customer_application:modal_message", (event, data) ->
                $scope.modal_message = data
          ]
        resolve:
          modal_message: ->
            initialMessage
      )
      @modal.result.then ( =>
        @modal = null
      ), ->
        @modal = null
    true

  rejectCounterOffer: (product_decision_id) ->
    @$http(
      method: "POST"
      data:
        product_decision_id: product_decision_id
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/reject_counter_offer"
    )

  closeLoadingModal: ->
    @$rootScope.$broadcast 'submitDisabled', false
    try
      if @modal
        @modal.dismiss "cancel"
        @modal = null
    catch error
      null
    true
  checkDeclined: (fromPage) ->
    if @ApplicationService.page is 'declined' and @$stateParams.stage isnt 'declined'
      @goToStage "declined"
      true
    else
      false

  goToStage: (stage) ->
    if _.contains(@static_routes, stage)
      @$state.go stage
    else if stage in ['verification', 'completed']
      @applicationCompleted()
    else
      @$state.go 'customer_application', stage: stage
      @closeLoadingModal()

  verificationStarted: ->
    loc = "#{@ConfigService.completePrefix}?customer_application_id=#{@ApplicationService.target_application_id()}&reason=completed"
    @$rootScope.$broadcast 'customer:redirect', loc
    @ApplicationService.track("verification").finally () =>
      @$window.location.replace loc

  applicationCompleted: ->
    loc = "#{@ConfigService.completePrefix}?customer_application_id=#{@ApplicationService.target_application_id()}&reason=completed"
    @$rootScope.$broadcast 'customer:redirect', loc
    @ApplicationService.track("completed").finally () =>
      @$window.location.replace loc

  redirectToLastPage: ->
    target_stage = _.last(@ApplicationService.viewable_pages) || 'home'

    if target_stage isnt "contract"
      @closeLoadingModal()

    if target_stage is "verification"
      @verificationStarted()
    else if target_stage is "completed"
      @applicationCompleted()
    else if target_stage isnt @$stateParams.stage
      @goToStage target_stage
    else
      # a redirect did NOT happen..we're on the right page
      return true
    # a redirect happened
    return false

  updateData: (page, data_to_update, fire_events) ->
    if fire_events
      for key, val of data_to_update
        if _.isObject val
          for key2, val2 of val
            @$rootScope.$broadcast "customer_application:field_saved:#{key}:#{key2}:before_save", val2
    @$timeout =>
      @$rootScope.$broadcast 'customer_application:modal_message', "Loading..."
    , 500
    promise = @$http(
      method: "PUT"
      data:
        data: data_to_update
        page: page
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/save_field"
    ).then((response) =>
      if fire_events
        for key, val of data_to_update
          if _.isObject val
            for key2, val2 of val
              @$rootScope.$broadcast "customer_application:field_saved:#{key}:#{key2}:after_save", val2
      response
    )
    promise

  setRiskBasedDisclosure: (request_data) ->
    @$http(
      method: "POST"
      data: request_data
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/risk_based_disclosure"
    )
  addPromotion: (coupon_code) ->
    @$http(
      method: "POST"
      data:
        coupon_code: coupon_code
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/add_promotion"
    )
  removePromotion: (promotion) ->
    @$http(
      method: "POST"
      data:
        promotion_id: promotion.id
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/remove_promotion"
    )

  # DEPRECATED (still used in refi and Regions)
  # Use `getDeclinedPartnerOffers` instead
  getDeclinedOptions: ->
    @$http(
      method: "GET"
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/declined_option"
    )

  # Replaces the deprecated `getDeclinedOptions` function
  getDeclinedPartnerOffers: ->
    @$http(
      method: "GET"
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/declined_partner_offers"
    )

  markOfferViewed: (path) ->
    @$http(method: 'POST', url: path)

  getIo: ->
    @$http(
      method: "GET"
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/needs_io"
    ).then((response) =>
      { data } = response
      if data && data.needs_io is true
        script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = data.script_url
        $("body").append(script)
      response
    )

  getNeuroIdMetadata: ->
    @$http(
      method: "GET"
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/neuro_id_metadata"
    )

  setNeuroIdSessionId: (id) ->
    @$http(
      method: "POST"
      data:
        neuro_id_session_id: id
      url: "#{@ConfigService.apiBaseUrl(@ApplicationService.target_application_id())}/neuro_id_session_id"
    )

angular
.module("angularAvant.services")
.service("CustomerApplicationService", [
  "$http",
  "ConfigService",
  "ApplicationService",
  "$state",
  "$stateParams",
  "$rootScope",
  "$modal",
  "$timeout",
  "$window",
  CustomerApplicationService
])


if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = CustomerApplicationService
  exports.CustomerApplicationService = CustomerApplicationService
else
  window.CustomerApplicationService = CustomerApplicationService
